export function getUser() {
  try {
    const u = localStorage.getItem('tw1_user');
    return u ? JSON.parse(u) : null;
  } catch (e) { console.warn('[Auth] User parse failed:', e.message); return null; }
}

export function getToken() {
  return localStorage.getItem('tw1_token');
}

export function setAuth(token, user) {
  localStorage.setItem('tw1_token', token);
  localStorage.setItem('tw1_user', JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem('tw1_token');
  localStorage.removeItem('tw1_user');
}

export function isAdmin() {
  const u = getUser();
  return u?.rol === 'admin';
}

export function getPermissions() {
  const u = getUser();
  if (!u) return [];
  if (u.rol === 'admin') return null; // null = all access
  return u.permissions || [];
}

export function hasPageAccess(pageKey) {
  const u = getUser();
  if (!u) return false;
  if (u.rol === 'admin') return true;
  const perms = u.permissions || [];
  return perms.includes(pageKey);
}
